// extracted by mini-css-extract-plugin
export default {"card_profile":"ContactInfoLoader_card_profile__PPtvc","card_details":"ContactInfoLoader_card_details__qrVvy"};